import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RepositoryService {

  constructor(
  ) { }

  // TODO migrate to new API
  public async getDownloadLink(reference: string): Promise<string> {
    return await '';
    //return await this.angularFireStorage.ref(reference.replace('gs://' + environment.firebaseConfig.storageBucket, '')).getDownloadURL().toPromise();
  }

}
